import Sentry from '../../common/utils/middleware/config.sentry';
import axios from 'axios';

export const extractDataFromComprobante = async (file) => {
    try {
        const fileExtension = file.name.split('.').pop().toLowerCase();
        const imageExtension = fileExtension === 'jpg' ? 'jpeg' : fileExtension
        const mimeType = fileExtension === 'pdf'
            ? 'application/pdf'
            : `image/${imageExtension}`;

        const { data } = await axios.post(`${import.meta.env.VITE_N8N_FACTURA_API_URL}`, file, {
            headers: {
                'Content-Type': mimeType,
                'Authorization': `Bearer ${import.meta.env.VITE_N8N_FACTURA_API_KEY}`
            }
        });

        return data;
    }
    catch (error) {
        Sentry.withScope((scope) => {
            scope.setTag("service", "extractDataFromComprobante");
            scope.setTag("api", "n8n-deteccion-factura");

            scope.setExtra("fileName", file?.name);
            scope.setExtra("fileSize", file?.size);
            scope.setExtra("mimeType", error.config?.headers?.["Content-Type"]);
            scope.setExtra("status", error.response?.status);
            scope.setExtra("response", error.response?.data);

            Sentry.captureMessage(
                "n8n: No se pudo extraer datos del comprobante",
                "warning"
            );
        });
    }
};